/**
 * APP: Taako.
 *
 * Cloud container
 * Generates all the moving clouds. Note: all 1 texture.
 * its hooked into the react-pixi provider to get the PIXI
 * tick event.
 *
 * Possibly can remove it and use GSAP ?
 * It seems that react is not ment for animations.
 * Funny as its billed as a RENDER only framework.
 *
 * reason is setState is not performant and drops frames
 * since its batched. means that it doesnt matter what you
 * do... you dont get your 60fps.
 *
 * So if react isnt good for animations, and has no backing
 * framework... ie: models or collections etc.. then....
 * why react at all ?
 *
 */

import React from 'react';
import { Container, Sprite } from '@inlet/react-pixi';

export class Clouds extends React.Component {

  state = {
    cloud_1_currX: window.innerWidth + 200,
    cloud_2_currX: 400,
    cloud_3_currX: 1000,
    cloud_4_currX: 1500,
    cloud_5_currX: window.innerWidth - 100,
  }

  componentDidMount() {
    this.props.app.ticker.add(this.tick)
  }

  componentWillUnmount() {
    this.props.app.ticker.remove(this.tick)
  }

  positionTracker = ( currentX, speed ) => {
    return ( currentX < -300 ) ? window.innerWidth + 400 : currentX - speed;
  }

  tick = (delta) => {
    this.setState({
      cloud_1_currX: this.positionTracker(this.state.cloud_1_currX,
        this.props.cloudData[0].speed),
      cloud_2_currX: this.positionTracker(this.state.cloud_2_currX,
        this.props.cloudData[1].speed),
      cloud_3_currX: this.positionTracker(this.state.cloud_3_currX,
        this.props.cloudData[2].speed),
      cloud_4_currX: this.positionTracker(this.state.cloud_4_currX,
        this.props.cloudData[3].speed),
      cloud_5_currX: this.positionTracker(this.state.cloud_5_currX,
        this.props.cloudData[4].speed),
    })
  }

  render() {
    return (
      <Container>
        <Sprite key={'cloud-1'}
                texture={this.props.texture[this.props.cloudData[0].useTexture]}
                scale={this.props.cloudData[0].scale}
                alpha={this.props.cloudData[0].alpha}
                anchor={[0.5,0.5]}
                x={this.state.cloud_1_currX}
                y={this.props.cloudData[0].position.sy}/>
        <Sprite key={'cloud-2'}
                texture={this.props.texture[this.props.cloudData[1].useTexture]}
                scale={this.props.cloudData[1].scale}
                alpha={this.props.cloudData[1].alpha}
                anchor={[0.5,0.5]}
                x={this.state.cloud_2_currX}
                y={this.props.cloudData[1].position.sy}/>
        <Sprite key={'cloud-3'}
                texture={this.props.texture[this.props.cloudData[2].useTexture]}
                scale={this.props.cloudData[2].scale}
                alpha={this.props.cloudData[2].alpha}
                anchor={[0.5,0.5]}
                x={this.state.cloud_3_currX}
                y={this.props.cloudData[2].position.sy}/>
        <Sprite key={'cloud-4'}
                texture={this.props.texture[this.props.cloudData[3].useTexture]}
                scale={this.props.cloudData[3].scale}
                alpha={this.props.cloudData[3].alpha}
                anchor={[0.5,0.5]}
                x={this.state.cloud_4_currX}
                y={this.props.cloudData[3].position.sy}/>
        <Sprite key={'cloud-5'}
                texture={this.props.texture[this.props.cloudData[4].useTexture]}
                scale={this.props.cloudData[4].scale}
                alpha={this.props.cloudData[4].alpha}
                anchor={[0.5,0.5]}
                x={this.state.cloud_5_currX}
                y={this.props.cloudData[4].position.sy}/>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Clouds.js